/**
 * 1.8.4 (D-1.8.4-6) — the requests of the trimmed Events page that are new: Request volunteers with its audience (an
 * event's own press, `what: 'requestVolunteers'`), and the reports of Past events as a PDF.
 */
import type { EventSendResult } from '@shared/events';
import type { RequestAudience } from '@shared/volunteer-audience';
import { apiFetch } from '@/lib/api';
import { press } from './api';

/** Request volunteers — to whom. It goes out in parts: press on while `remaining` is above 0, with the same audience. */
export const requestVolunteersToReq = (eventId: string, audience: RequestAudience) => press<EventSendResult>(eventId, { what: 'requestVolunteers', audience });

/** Past events → Generate report → PDF: one event's report, or the last 12 months (counts only, on letterhead). */
export const reportPdfReq = (body: { scope: 'event'; eventId: string; lang: 'en' | 'es' } | { scope: 'year'; lang: 'en' | 'es' }) => apiFetch<{ name: string; base64: string }>('/api/events/report', { method: 'POST', body: JSON.stringify(body) });
